<template>
  <div>

    <form-wizard 
      v-if="!isLoading || !esEditar"
      color="#7367F0" 
      :title="null" 
      :subtitle="null" 
      :finish-button-text="esEditar ? 'Guardar' : 'Crear'"
      back-button-text="Retroceder" 
      next-button-text="Siguiente"
      class="wizard-vertical mb-4"
      @on-complete="formSubmittedAdmision" 
      @before-change="beforeStepChange"
    >

      <tab-content 
        title="Paciente." 
        :before-change="validationPacientes"
      > 
      
        <validation-observer ref="pacRules" tag="form">
          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">
                Información del paciente
              </h5>
              <small class="text-muted">
                Ingresa la información del paciente
              </small>
            </b-col>

            <b-col md="6">
              <b-form-group label-for="v-tipo-ident">
                <label>Tipo Identificación: <span class="text-danger">*</span></label>
                <validation-provider 
                  v-slot="{ errors }" 
                  name="tipoIdentificacion" 
                  rules="required"
                >

                  <v-select
                    id="v-tipoIdentificacion"
                    v-model="paciente.tipoIdentificacion"
                    :options="optsTipoIdentificacion"
                    label="text"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label-for="mc-identificacion">
                <label>Identificación: <span class="text-danger">*</span></label>
                <validation-provider 
                  v-slot="{ errors }" 
                  name="identificacion" 
                  :rules="identificacionRules"
                >
                  <b-form-input 
                    id="mc-identificacion" 
                    v-model="paciente.identificacion" 
                    placeholder="0999999999"
                    name="identificacion" 
                    :type="inputType"
                    :maxlength="maxInputLength"
                    :state="errors.length > 0 ? false : null" 
                  />
                  <div v-if="errors.length > 0" class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                  <p v-if="identificacionRepetida" style="color: red;">¡La identificación ya existe! Ingrese otra por favor</p>
                </validation-provider>
              </b-form-group>
            </b-col>

          </b-row>

          <b-row>
            <b-alert
              v-if="existePaciente.value" 
              variant="danger" 
              show
              class="text-center col-12 mt-2"
              style="padding: 40px; font-size: 20px;"
            >
              <i class="fa-solid fa-triangle-exclamation"/>
              Ya existe un paciente registrado con este numero de cedula
              <div class="mt-1 d-flex justify-content-center">
                <h5 class="text-white mt-1">{{ existePaciente.nombre }}</h5>
                <b-button 
                  class="ml-2" 
                  size="sm" 
                  variant="info"
                  @click="onViewDataPaciente(existePaciente.token)"
                >
                  <i class="fa-solid fa-eye"/>
                </b-button>
              </div>
            </b-alert>
          </b-row> 

          <b-row v-if="showFormularioPersona">
            <b-col md="6">
              <b-form-group label-for="vlastname">
                <label>Apellidos: <span class="text-danger">*</span></label>
                <validation-provider 
                  #default="{ errors }" 
                  name="apellidos" 
                  rules="required"
                >
                  <b-form-input 
                    id="v-lastname" 
                    :state="errors.length > 0 ? false : null" 
                    v-model="paciente.apellidos" 
                    type="text"
                    placeholder="Escriba su apellido" 
                    @input="convertirAMayusculas" 
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label-for="v-name">
                <label>Nombres: <span class="text-danger">*</span></label>
                <validation-provider #default="{ errors }" name="nombre" rules="required">
                  <b-form-input 
                    id="v-name" 
                    :state="errors.length > 0 ? false : null" 
                    v-model="paciente.nombres"
                    placeholder="Escriba su nombre" 
                    @input="convertirAMayusculas" 
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label-for="v-datebirth">

                <label>Fecha de nacimiento: <span class="text-danger">*</span></label>
                <validation-provider v-slot="{ errors }" name="fechaNacimiento" rules="required">
                  <flat-pickr
                    class="flatpickr-container"
                    v-model="paciente.fechaNacimiento" 
                    :state="errors.length > 0 ? false : null" 
                    locale="es"
                    :config="flatpickrConfig" 
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <label>Nacionalidad: <span class="text-danger">*</span></label>
              
              <validation-provider 
                v-slot="{ errors }" 
                name="nacionalidad" 
                rules="required"
              >
                <v-select 
                  id="v-nacionalidad" 
                  v-model="paciente.nacionalidad"
                  :options="optsNacionalidades"
                  label="text"
                  taggable
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>


            <b-col md="6">
              <b-form-group label-for="v-sexo">
                <label>Sexo <span class="text-danger">*</span> </label>
                <validation-provider 
                  v-slot="{ errors }" 
                  name="sexo" 
                  rules="required"
                >
                  <v-select 
                    id="v-sexo" 
                    v-model="paciente.sexo" 
                    :options="optsSexo" 
                    label="text" 
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            
            <b-col md="6">
              <b-form-group label-for="v-cell">
                <label>Celular: <span class="text-danger">*</span></label>
                <validation-provider 
                  #default="{ errors }" 
                  name="celular" 
                  rules="required|integer|digits:10"
                >

                  <b-form-tags 
                    id="v-cell" 
                    input-id="tags-validation" 
                    v-model="paciente.celular"
                    :input-attrs="{ 'aria-describedby': 'tags-validation-help' }" 
                    :tag-validator="tagValidator"
                    :state="errors.length > 0 ? false : null" 
                    separator=" " 
                    input-type="number"
                    placeholder="099999999" 
                  />

                  <small class="text-danger">{{ errors[0] }}</small>

                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              
              <label>Profesion / Ocupacion <span class="text-danger">*</span></label>
              <validation-provider 
                v-slot="{ errors }" 
                name="profesion" 
                rules="required"
              >
                <v-select 
                  id="v-profesion" 
                  v-model="paciente.profesion" 
                  :options="optsProfesiones" 
                  label="text"
                  taggable
                />

                <!-- <SearchOpts
                  :searchService="onFilterProfesiones"
                  v-model="paciente.profesion"
                  label="text"
                /> -->

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
              
            </b-col>
          </b-row>

          <hr class="my-3">  
          
          <b-row v-if="showFormularioPersona">

            <b-col md="12" class="d-flex align-items-center justify-content-end mb-1">
              <label class="mr-1">Discapacitado:</label> 
              <b-form-checkbox 
                v-model="paciente.esDiscapacitado" 
                switch
              />      
            </b-col>

            <b-col md="6">
              <b-form-group label="Estado Civil" label-for="v-estadocivil">
                <v-select 
                  id="v-est-civil" 
                  v-model="paciente.estadoCivil" 
                  :options="optsEstadoCivil" 
                  label="text" 
                />
              </b-form-group>
            </b-col>


            <b-col md="6">
              <b-form-group label-for="mc-email">
                <label>Correo eletrónico:</label>
                <validation-provider 
                  #default="{ errors }" 
                  name="Correo eletrónico" 
                  rules="email"
                >
                  <b-form-input 
                    id="mc-email" 
                    v-model="paciente.email" 
                    placeholder="ana@example.com" 
                    name="email"
                    :state="errors.length > 0 ? false : null" 
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>


            <b-col md="6">
              <b-form-group 
                label="Nivel Educacion" 
                label-for="v-nivelEcuacion"
              >
                <v-select 
                  id="v-nivelEcuacion" 
                  v-model="paciente.nivelEducacion"
                  :options="optsNivelesEducacion"
                  label="text" 
                />
              </b-form-group>
            </b-col>

            

            <b-col md="6">
              <b-form-group 
                label="Nacionaliad Etnica" 
                label-for="v-nacioEtni"
              >
                <v-select 
                  id="v-nacioEtni" 
                  v-model="paciente.nacionalidadEtnica" 
                  :options="optsNacionalidadesEtnica" 
                  label="text" 
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group 
                label="Pueblos Kichwa" 
                label-for="v-pueKichwa"
              >
                <v-select 
                  id="v-pueKichwa" 
                  v-model="paciente.puebloKichwa" 
                  :options="optsPueblosKichwa" 
                  label="text" />
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>



      <!-- personal info tab -->
      <tab-content 
        title="Residencia" 
        :before-change="validationResidencia"
      >
    
        <validation-observer ref="resiRules" tag="form">

          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">
                Residencia
              </h5>
              <small class="text-muted">Ingrese la residencia del paciente.</small>
            </b-col>
            
            <b-col md="6">
              <div>
                <label>Pais <span class="text-danger">*</span></label>
                <v-select 
                  id="v-pais" 
                  v-model="residencia.pais" 
                  :options="optsPais" 
                  label="text" 
                />
              </div>
            </b-col>
          </b-row>


          <b-row v-if="!viveInEcuador && residencia.pais">
            <b-col md="6">
              <b-form-group label-for="v-cprincipal">
                <label>Descripcion Dirección Domiciliaria <span class="text-danger">*</span></label>
                <validation-provider 
                  #default="{ errors }" 
                  name="calle principal" 
                  rules="required"
                >
                  <b-form-input 
                    id="v-cprincipal" 
                    :state="errors.length > 0 ? false : null" 
                    v-model="residencia.callePrincipal"
                    type="text" 
                    placeholder="Detalle calle principal" 
                  />
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>


          <b-row v-if="viveInEcuador" class="my-1">
            <b-col md="6" >
              <label>Provincia <span class="text-danger">*</span> </label> 
              <v-select 
                id="v-provincia" 
                v-model="residencia.provincia" 
                :options="optsProvincia" 
                label="text" 
                :disabled="optsProvincia.length === 0"
              />
            </b-col>

            <b-col md="6">
              <label>Canton <span class="text-danger">*</span> </label> 
              <validation-provider 
                v-slot="{ errors }" 
                name="canton" 
                rules="required"
              >
                <v-select 
                  id="v-canton" 
                  v-model="residencia.canton" 
                  :options="optsCanton" 
                  label="text"
                  :disabled="optsCanton.length === 0"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
                
            </b-col>

            <b-col md="6" class="mt-1">
              <label>Parroquia <span class="text-danger">*</span> </label> 
              <validation-provider 
                v-slot="{ errors }" 
                name="parroquia" 
                rules="required"
              >
                <v-select 
                  id="v-parroquia" 
                  v-model="residencia.parroquia" 
                  :options="optsParroquia" 
                  label="text"
                  :disabled="!residencia.canton"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
              
            </b-col>

            <b-col md="6" class="mt-1">
              <b-form-group label="Barrio" label-for="v-barrio">
                <!-- <v-select 
                  id="v-barrio" 
                  v-model="residencia.barrio" 
                  :options="optsBarrio" 
                  label="text"
                  taggable
                  :disabled="!residencia.parroquia"
                /> -->

                <b-form-input 
                  id="v-barrio" 
                  v-model="residencia.barrio" 
                  type="text"
                  :disabled="!residencia.parroquia"
                />  
              </b-form-group>
            </b-col>

            <hr class="col-12">  

            <b-col md="6">
              <b-form-group label-for="v-cprincipal">
                <label>Dirección Domiciliaria <span class="text-danger">*</span></label>
                <validation-provider 
                  #default="{ errors }" 
                  name="calle principal" 
                  rules="required"
                >
                  <b-form-input 
                    id="v-cprincipal" 
                    :state="errors.length > 0 ? false : null" 
                    v-model="residencia.callePrincipal"
                    type="text" 
                    placeholder="Detalle calle principal" 
                  />
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group 
                label="Calle Secundaria" 
                label-for="v-csecundaria"
              >
                <b-form-input 
                  id="v-csecundaria" 
                  v-model="residencia.calleSecundaria" 
                  type="text"
                  placeholder="Detalle calle secundaria" 
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Referencia" label-for="v-referenciasect">
                <b-form-input 
                  id="v-referenciasect" 
                  v-model="residencia.referencia" 
                  type="text"
                  placeholder="Detalle alguna referencia" 
                />
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>


      <!-- documentos -->
      <tab-content title="Documentos" :before-change="validationFormDocu">
        <validation-observer ref="docRules" tag="form">

          <b-row class="d-flex align-items-center my-2">
            <!-- <b-form-checkbox/> -->
            <h6 class="mx-1">Historia Clinica IESS:</h6>
            <b-form-input 
              class="col-2"
              v-model="numHistoriaClinica"
              type="text"
              @keypress="onlyNumbers"
            />
          </b-row>

          <hr class="my-2">

          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">Documentos</h5>
              <small class="text-muted">Agregar los documentos necesarios</small>
            </b-col>
          </b-row>

          <b-row>
            <b-card class="col-12" style="border: 1px solid #c9c9c9">
              <h5>{{paciente.identificacion + ' - ' + paciente.apellidos + ' ' + paciente.nombres}}</h5>
              <hr>

              
              <LoadFileInput
                label="Identificacion"
                v-model="paciente.cedulaFile"
                :urlFile="paciente.urlIdentificacion"
                inline
              />

              <hr>

              <LoadFileInput
                label="Carnet ISSFA"
                v-model="paciente.carnetIssfa"
                :urlFile="paciente.urlCarnetIssfa"
                inline
              />

              <hr>

              <LoadFileInput
                label="Carnet ISSPOL"
                v-model="paciente.carnetIsspol"
                :urlFile="paciente.urlCarnetIsspol"
                inline
              />

              <hr>

              <LoadFileInput
                label="Carnet discapacidad"
                v-model="paciente.carnetDiscapacidad"
                :urlFile="paciente.urlCarnetDiscapacidad"
                inline
              />
            </b-card>
          </b-row> 

          
        </validation-observer>
      </tab-content>
    </form-wizard>
    
    <GeneralLoader v-if="isLoading && esEditar" :size="'100'" class="my-5"/>


    <ModalViewFile
      v-if="fileToView"
      :urlFile="fileToView"
      :rutaCompleta=isRutaCompleta
      v-model="isModalFileVisible"
    />

    <ModalCrearPersona />

    <VerAdmision :canEdit="false"/>

  </div>

</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import { required, email } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import { BootstrapVue } from 'bootstrap-vue';
import { ModalViewFile, GeneralLoader, LoadFileInput } from '@/shared/components';
import {  getEstablecimientoLS, getItemByValueId, getItemByTextUpperCase, onlyNumbers } from "@/shared/helpers";
import flatPickr from 'vue-flatpickr-component';

import axios from 'axios';
import { fileService } from '@/shared/services';
import { ModalCrearPersona } from '@/views/administracion/components';

import 'flatpickr/dist/flatpickr.css';
import { personasService, 
  infoPersonasService, pacientesService,
} from '../services';

import { VerAdmision } from '../components';
import { validationsPerson } from '../helpers';


export default {

  props: {
    esEditar: {
      type: Boolean,
      default: false
    }
  },

  components: {
    ...BootstrapVue.components,
    FormWizard,
    ValidationProvider,
    ValidationObserver,
    TabContent,
    
    flatPickr,
    vSelect,
    ModalViewFile,
    ModalCrearPersona,
    VerAdmision,
    GeneralLoader,
    LoadFileInput,
  },


  async created() {  

    await this.loadDataInit();
    await this.loadDataPaciente();

    this.comprobarPermisos();
    this.setToken();
    this.beforeStepChange();
  },
  
  data() {
    return {
      onlyNumbers,

      cargaInicial: true,

      establecimientoAdmision: null,

      existePersona: null,
      cargoPersona: null,

      isLoading: this.esEditar,
      blockScreen: this.esEditar,

      cedulaInicial: null,

      identificacionRepetida: false,

      existePaciente: {
        value: null,
        token: null,
        nombre: null
      },

      numHistoriaClinica: null,

      paciente:{
        tipoIdentificacion : null,
        identificacion     : null,
        apellidos          : null,
        nombres            : null,
        fechaNacimiento    : null,
        nacionalidad       : null,
        sexo               : null,
        celular            : null,

        estadoCivil        : null,
        email              : null,
        nivelEducacion     : null,
        profesion          : null,
        nacionalidadEtnica : null,
        puebloKichwa       : null,

        urlIdentificacion     : null,
        urlCarnetIssfa        : null,
        urlCarnetIsspol       : null,
        urlCarnetDiscapacidad : null,

        cedulaFile        : null,
        carnetIssfa       : null,
        carnetIsspol      : null,
        carnetDiscapacidad: null
      },

      
      residencia: {
        pais            : null,
        provincia       : null,
        canton          : null,
        parroquia       : null,
        barrio          : null,
        callePrincipal  : null,
        calleSecundaria : null,
        referencia      : null
      },

      minCaracteresIdentificacion : false,

      seguro:{
        historiaClinica : null,
      },

      personasService,

      fileToView: null,
      isModalFileVisible:false,
      isRutaCompleta: false,

      process: [],

      titularEdit:{},

      tokenPacienteAddHistoriaClinica:null,
      showModalHistoriaClinica:false,

      personaPaciente: null,

      //
      required,
      email,
      date: null,
      
      alertValidateSexo: false,

      tipoIdentValidation: null,
      tipoIdentErrors: [],
      identificacionValidation: null,
      identificacionErrors: [],
      
      
      flatpickrConfig: {
        allowInput: true, // Muestra un campo de entrada de texto adicional
        minDate:'1900-01-01',
        maxDate:new Date(),
      },

      identificaciones: [],

      optsNacionalidades      : [],
      optsNivelesEducacion    : [],
      optsProfesiones         : [],
      optsNacionalidadesEtnica: [],
      optsPueblosKichwa       : [],

      optsPais      : [],
      optsProvincia : [],
      optsCanton    : [],
      optsParroquia : [],
      optsBarrio    : [],

      optsSexo: [
        { value: '0', text: 'Masculino' },
        { value: '1', text: 'Femenino' }
      ],
      
      optsEstadoCivil: [
        { value: '0', text: 'Soltero/a' },
        { value: '1', text: 'Casado/a' },
        { value: '2', text: 'Divorciado/a' },
        { value: '3', text: 'Separado/a' },
        { value: '4', text: 'Viudo/a' },
        { value: '5', text: 'Union Hecho' }
      ],

      optsTipoIdentificacion: [
        { value: '0', text: 'RUC' },
        { value: '1', text: 'Cedula' },
        { value: '2', text: 'Passporte' }
      ],
    }
  },


  methods: {

    async loadDataInit() {

      this.establecimientoAdmision  = getEstablecimientoLS();

      this.optsNacionalidades       = await infoPersonasService.getNacionalidades();
      this.optsNivelesEducacion     = await infoPersonasService.getNivelesEducacion();
      // this.optsProfesiones          = await infoPersonasService.getProfesiones();
      this.optsProfesiones          = await this.onFilterProfesiones();
      this.optsNacionalidadesEtnica = await infoPersonasService.getNacionalidadesEtnicas();
      this.optsPueblosKichwa        = await infoPersonasService.getPueblosKichwa();
      this.optsPais                 = await infoPersonasService.getPaises();
    },


    // filtra para que no se muestren repetidos
    async onFilterProfesiones() {
      const responseProfesiones = await infoPersonasService.getProfesiones();
      const seen = new Set();
      const filteredProfesiones = responseProfesiones.filter(profesion => {

        const normalizedText = profesion.text.toUpperCase().trim();
        if (seen.has(normalizedText)) return false;
        
        seen.add(normalizedText);
        return true;
      });

      return filteredProfesiones;
    },


    async loadDataPaciente(){
      if(!this.esEditar) return;

      const { tokenPaciente } = this.$route.params;
      if(!tokenPaciente) return;

      this.tokenPaciente = tokenPaciente;
      const responsePaciente = await pacientesService.getAll({ tokenPaciente });

      const dataPaciente = responsePaciente?.pacientes[0];

      if(!dataPaciente){
        this.tokenPaciente = null;
        await this.$swal('Error', 'La admision no existe', 'error');
        this.$router.push({ name: 'consultar_admision' });
        return;
      }

      this.paciente.identificacion = dataPaciente?.persona.identificacion;
      this.cedulaInicial = dataPaciente?.persona.identificacion;

    },


    async onSearchPersona(query){

      const searchPersonas = await personasService.searchByQuery(query);
      this.existePersona = !!searchPersonas.length;

      if(!this.existePersona) return;

      const persona = searchPersonas[0];

      if(this.esEditar){
        if(persona){
          if(persona.identificacion !== this.cedulaInicial){

            await this.$swal({
              title: 'Identificacion encontrada',
              icon: 'error',
              text: 'Ya existe informacion de otra persona con esa cedula',
            });

            this.paciente.identificacion = this.cedulaInicial;
            return;
          }
        }
      }

      if (!this.esEditar && persona) {
        const result = await this.$swal({
          title: 'Info!',
          icon: 'info',
          text: 'Identificacion encontrada. Desea cargar la data?',
          showCancelButton: true,
          confirmButtonText: 'Sí',
        });

        this.cargoPersona = !!result.isConfirmed;

        if(!result.isConfirmed) return;
      }


      const tipoIdentificacion = getItemByValueId( this.optsTipoIdentificacion, persona.tipoIdentificacion.toString() );
      const nivelEducacion = persona.nivelEducacion 
        ? { value: persona.nivelEducacion?.id, text: persona.nivelEducacion.descripcion }
        : null;

      const profesion = persona.ocupacion 
        ? { value: persona.ocupacion?.id,      text: persona.ocupacion.descripcion }
        : null;

      const nacionalidad = persona.nacionalidad 
        ? { value: persona.nacionalidad?.id,   text: persona.nacionalidad.descripcion }
        : null;

      const sexo        = getItemByValueId( this.optsSexo, persona.sexo.toString() )
      const estadoCivil = getItemByValueId( this.optsEstadoCivil, persona.estadoCivil.toString() )

      const nacionalidadEtnica = persona.nacionalidadEtnia 
        ? { value: persona.nacionalidadEtnia?.id, text: persona.nacionalidadEtnia.descripcion }
        : null;

      const puebloKichwa = persona.pueblokichwa 
        ? { value: persona.pueblokichwa?.id,       text: persona.pueblokichwa.descripcion }
        : null;

      this.paciente  = {
        tokenPersona       : persona.token,
        tipoIdentificacion : tipoIdentificacion,
        identificacion     : persona.identificacion,
        apellidos          : persona.primerApellido,
        nombres            : persona.primerNombre,
        fechaNacimiento    : persona.fechaNacimiento,
        nacionalidad,
        sexo,
        celular            : persona.telefono.split(','),

        esDiscapacitado    : !!persona.esDiscapacitado,
        estadoCivil,
        email                 : persona.correo,
        urlIdentificacion     : persona.urlIdentificacion,
        urlCarnetIssfa        : persona.urlCarnetIssfa,
        urlCarnetIsspol       : persona.urlCarnetIsspol,
        urlCarnetDiscapacidad : persona.urlCarnet,

        cedulaFile        : null,
        carnetIssfa       : null,
        carnetIsspol      : null,
        carnetDiscapacidad: null,

        nivelEducacion,
        profesion,
        nacionalidadEtnica,
        puebloKichwa,
      };

      const { residencia } = persona;
      const pais = getItemByValueId( this.optsPais, residencia?.pais?.id.toString() );

      const dataUbicacion = infoPersonasService.getUbicacionByParroquia(residencia?.parroquia);

      const provincia = dataUbicacion 
        ? dataUbicacion.provincia
        : { value: residencia?.canton?.idprovincia?.id, text: residencia?.canton?.idprovincia?.descripcion };

      const canton = dataUbicacion
        ? dataUbicacion.canton
        : { value: residencia?.canton?.id, text: residencia.canton?.descripcion };

      const parroquia = dataUbicacion
        ? dataUbicacion.parroquia
        : residencia?.parroquia;


      this.residencia = {
        pais,
        provincia,
        canton,
        parroquia,
        barrio          : residencia.barrio,
        callePrincipal  : residencia.callePrincipal,
        calleSecundaria : residencia.calleSecundaria,
        referencia      : residencia.referenciaSector
      };

    },


    async onSearchPaciente(query){

      const params = {
        search: query,
      };

      const responsePaciente = await pacientesService.getAll(params);
      const pacienteSearch = responsePaciente.pacientes[0];

      this.existePaciente = {
        value : !!pacienteSearch,
        token : pacienteSearch?.token || null,
        nombre: `${pacienteSearch?.persona.primerNombre} ${pacienteSearch?.persona.primerApellido}` || null
      }

      const historiaClinicaDb  = pacienteSearch?.numHistoriaClinica;
      const historiaClinicaObj = historiaClinicaDb ? JSON.parse(historiaClinicaDb) : {};
      const historiaClinicaEst = historiaClinicaObj && historiaClinicaObj[this.establecimientoAdmision.id];

      this.numHistoriaClinica = historiaClinicaEst;

      if(this.esEditar){
        const cedulaEncontrada = pacienteSearch?.persona.identificacion;

        if (this.cedulaInicial === cedulaEncontrada)
          this.existePaciente =  {
            value: false,
            token: null,
            nombre: null,
          }
      }
    },


    onViewDataPaciente(token) {
      this.$router.push({ name: 'crear_admision', query: { view_admision: token } });
    },


    onViewFile(urlF) { 
      this.fileToView = urlF;
      this.isModalFileVisible = true;
    },


    onViewFileLocal(file){
      
      if(!(file instanceof File)){
        console.error('file no es instancia de File');
        return;
      }

      const fileReader = new FileReader();
      fileReader.onload = (event) => {
        this.fileToView = event.target.result;
        this.isModalFileVisible = true;
        this.isRutaCompleta = true;
      };

      fileReader.readAsDataURL(file);
    },

    
    tagValidator(tag) {
      const isValid = /^\d+$/.test(tag) && tag.length < 11
      this.tagError = isValid ? '' : 'Solo se permiten valores numéricos hasta de 10 caracteres'
      return isValid
    },

   
    convertirAMayusculas() {
      if (this.paciente.nombres)
        this.paciente.nombres   = this.paciente.nombres.replace(/[0-9]/g, '').toUpperCase();

      if (this.paciente.apellidos)
        this.paciente.apellidos = this.paciente.apellidos.replace(/[0-9]/g, '').toUpperCase();
    },


    comprobarPermisos() {
      if (localStorage.getItem('permisos').indexOf('adm_crear_admision') === -1) {
        this.$router.push({ name: 'not-permitted' })
      }
    },
    

    beforeStepChange(newStep, oldStep, prevent) {
      if (newStep > oldStep) {
        prevent();
      }
    },


    validationPacientes() {
      return new Promise(async (resolve, reject) => {
        if (this.existePersona && !this.cargoPersona && !this.esEditar) {
          this.$swal({
            title: 'Ya existe una persona con esa identificación',
            icon: 'error',
          });
          reject();
        }

        if (this.existePaciente.value) {
          this.$swal({
            title: 'Error',
            text: 'Ya existe una admisión con esa cédula',
            icon: 'error',
          });
          reject();
        }

        const sexoSeleccionado = this.paciente.sexo?.value;
        if (sexoSeleccionado !== '0' && sexoSeleccionado !== '1') {
          this.$swal({
            title: 'Campos vacíos',
            text: 'Debe seleccionar el sexo del paciente',
            icon: 'error',
          });
          reject();
        }

        this.$refs.pacRules.validate().then(success => {
          if (success && this.identificacionRepetida === false) {
            resolve(true);
          } else {
            this.$swal({
              title: this.identificacionRepetida ? "Identificación repetida" : "Campos vacíos",
              text: this.identificacionRepetida ? "Debe ingresar una identificación diferente " : "Debe llenar todos los campos obligatorios",
              icon: 'error',
              confirmButtonText: 'Ok'
            });
            reject();
          }
        });
      });
    },


    validationResidencia() {
      return new Promise((resolve, reject) => {

        if(!this.residencia.pais){
          this.$swal({
            title: 'Campos vacíos',
            text: 'Llenar todos los campos',
            icon: 'error',
          });
          reject();
        }

        this.$refs.resiRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            this.$swal({
              title: 'Campos vacíos',
              text: 'Llenar todos los campos',
              icon: 'error',
              confirmButtonText: 'Entendido'
            })
            reject()
          }
        })
      })
    },


    async validationFormDocu() {
      const esHCRepetida = await this.validateHCRepetida();

      console.log(esHCRepetida);
      if (esHCRepetida) return false;

      return new Promise((resolve, reject) => {
        this.$refs.docRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            this.$swal({
              title: 'Campos vacíos',
              text: 'Llenar todos los campos',
              icon: 'error',
              confirmButtonText: 'Entendido'
            })
            reject()
          }
        })
      })
    },


    async validateHCRepetida() {
      if (!this.numHistoriaClinica) return false;

      const establecimiento = this.establecimientoAdmision.id
      const response = await pacientesService.searchByHistoriaClinica(this.numHistoriaClinica, establecimiento);

      if(this.esEditar)
        if (response?.persona?.identificacion === this.paciente?.identificacion) return false;

      if(!response) return false;
      
      this.$swal({
        title: 'Error',
        text: `Ya existe un paciente con ese numero de historia clinica ${response.persona.identificacion} - ${response.persona.primerApellido} ${response.persona.primerNombre}`,
        icon: 'warning',
        confirmButtonText: 'Entendido'
      });

      return true;
    },
    

    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'));
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`
    },


    async formSubmittedAdmision() {

      this.blockScreen = true;

      // 1. Guardar data persona
      const saveDataPersona = await this.onSaveDataPersona();

      // 2. Crear paciente
      const saveDataPaciente = await this.onSaveDataPaciente();


      const processHtml = this.process.map(item => {
        const status = item.value ? 'Ok' : 'Error';
        return `<li><strong>${item.descripcion}:</strong> ${status}</li>`;
      }).join(''); 

      this.process = [];
      
      await this.$swal({
        title: 'Informacion del paciente Guardada',
        icon: 'success',
        html: `<ul>${processHtml}</ul>`,
      });

      this.$router.push({ name: 'consultar_admision',  });

      this.blockScreen = false;
    },



    async onSaveDataPersona() {
      // crear persona
      let urlIdentificacion = null;
      let urlCarnetIssfa    = null;
      let urlCarnetIsspol   = null;
      let urlCarnetDiscapacidad = null;

      if(this.paciente.cedulaFile){
        urlIdentificacion =  await fileService.upload(
          'cedulas', 
          this.paciente.cedulaFile, 
          this.paciente.identificacion, 
          this.paciente.urlCedula
        );
      }

      if(this.paciente.carnetIssfa)
        urlCarnetIssfa = await fileService.upload(
          'carnetIssfa', 
          this.paciente.carnetIssfa, 
          this.paciente.identificacion, 
          this.paciente.urlCarnetIssfa
        );

      if(this.paciente.carnetIsspol)
        urlCarnetIsspol = await fileService.upload(
          'carnetIsspol', 
          this.paciente.carnetIsspol, 
          this.paciente.identificacion,
          this.paciente.urlCarnetIsspol
        );

      if(this.paciente.carnetDiscapacidad)
        urlCarnetDiscapacidad = await fileService.upload(
          'carnetDiscapacidad', 
          this.paciente.carnetDiscapacidad, 
          this.paciente.identificacion, 
          this.paciente.urlCarnetDiscapacidad
        );

      // eliminar archivos
      if(this.paciente.cedulaFile === undefined){
        const deleteFile = await fileService.deleteFile(this.paciente.urlIdentificacion);
        if(!deleteFile) return;
        urlIdentificacion = 'eliminado';
      } 
      
      if(this.paciente.carnetIssfa === undefined){
        const deleteIssfa = await fileService.deleteFile(this.paciente.urlCarnetIssfa);
        if(!deleteIssfa) return;
        urlCarnetIssfa = 'eliminado';
      }

      if(this.paciente.carnetIsspol === undefined){
        const deleteIsspol = await fileService.deleteFile(this.paciente.urlCarnetIsspol);
        if(!deleteIsspol) return;
        urlCarnetIsspol = 'eliminado';
      } 

      let idNacionalidad = this.paciente.nacionalidad.value;
      let idProfesion    = this.paciente.profesion.value;

      if(idProfesion === '00'){
        const responseNewProfesion = await infoPersonasService.createProfesion(this.paciente.profesion.text);
        if(!responseNewProfesion) return;
        idProfesion = responseNewProfesion.id;
      }

      if(idNacionalidad === '00'){        
        const responseNewNacionalidad = await infoPersonasService.createNacionalidad(this.paciente.nacionalidad.text);
        if(!responseNewNacionalidad) return;
        idNacionalidad = responseNewNacionalidad.id;
      }

      const dataNewPersona = {
        tokenPersona       : this.paciente.tokenPersona || null,
        tipoIdentificacion : this.paciente.tipoIdentificacion?.value,
        identificacion     : this.paciente.identificacion,
        apellidos          : this.paciente.apellidos,
        nombres            : this.paciente.nombres,
        fechaNacimiento    : this.paciente.fechaNacimiento,
        nacionalidad       : idNacionalidad,
        sexo               : this.paciente.sexo?.value,
        telefono           : this.paciente.celular.join(),

        estadoCivil        : this.paciente.estadoCivil?.value,
        email              : this.paciente.email,
        nivelEducacion     : this.paciente.nivelEducacion?.value,
        profesion          : idProfesion,
        puebloKichwa       : this.paciente.puebloKichwa?.value,
        nacionalidadEtnica : this.paciente.nacionalidadEtnica?.value,

        esDiscapacitado    : this.paciente.esDiscapacitado ? 1 : 0,

        urlIdentificacion     : urlIdentificacion,
        urlCarnetIssfa        : urlCarnetIssfa,
        urlCarnetIsspol       : urlCarnetIsspol,
        urlCarnet             : urlCarnetDiscapacidad,

        pais               : this.residencia.pais?.value,
        // canton             : this.residencia.canton?.value,
        parroquia          : this.residencia.parroquia?.value ? JSON.stringify(this.residencia.parroquia) : this.residencia.parroquia,
        barrio             : this.residencia.barrio,
        callePrincipal     : this.residencia.callePrincipal,
        calleSecundaria    : this.residencia.calleSecundaria,
        referencia         : this.residencia.referencia
      }


      if(this.esEditar){
        this.personaPaciente = await personasService.updateByToken( dataNewPersona.tokenPersona, dataNewPersona )
      }

      if(!this.esEditar){
        this.personaPaciente = (this.existePersona)
          ? await personasService.updateByToken( dataNewPersona.tokenPersona, dataNewPersona )
          : await personasService.addPersona(dataNewPersona);
      }


      this.process = [
        ...this.process, 
        { descripcion: 'paciente - persona', value: this.personaPaciente }
      ];
    },



    async onSaveDataPaciente() {

      const historiaClinicaLocal = {
        [this.establecimientoAdmision.id]: this.numHistoriaClinica || "000000"
      }

      // Crear paciente
      const newPaciente = {
        persona            : this.personaPaciente.id,
        numHistoriaClinica : JSON.stringify(historiaClinicaLocal),
        establecimiento    : this.establecimientoAdmision.id
      };

      const pacientePaciente = this.esEditar
        ? await pacientesService.updateByToken(this.tokenPaciente, newPaciente)
        : await pacientesService.createPaciente(newPaciente);

      this.process = [
        ...this.process,
        { descripcion: 'paciente - paciente', value: pacientePaciente }
      ]
    },



    onClearFormPaciente(){
      this.paciente = {
        ...this.paciente,
        tokenPersona       : null,
        // tipoIdentificacion : null,
        // identificacion     : null,
        apellidos          : null,
        nombres            : null,
        fechaNacimiento    : null,
        nacionalidad       : null,
        sexo               : null,
        celular            : null,

        estadoCivil        : null,
        email              : null,
        nivelEducacion     : null,
        profesion          : null,        
        nacionalidadEtnica : null,
        puebloKichwa       : null, 
      };

      this.residencia = {
        pais            : null,
        provincia       : null,
        canton         : null,
        parroquia       : null,
        barrio          : null,
        callePrincipal  : null,
        calleSecundaria : null,
        referencia      : null
      };

    },


    normalizeIdentificacion(value = '') {
      const tipoIdentificacion = this.paciente.tipoIdentificacion?.value;
      const rawValue = String(value || '').trim();

      if (tipoIdentificacion === '2')
        return rawValue.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

      return rawValue.replace(/[^0-9]/g, '');
    },


    async onChangeInputIdentificacion(newValue){

      this.minCaracteresIdentificacion = newValue.length >= this.minInputLength;

      if(this.esEditar){

        if(!this.minCaracteresIdentificacion) return;

        await this.onSearchPaciente(newValue);
        await this.onSearchPersona(newValue);
        this.isLoading = false;
        return;
      }


      
      if(this.minCaracteresIdentificacion){
        this.isLoading = true;
        await this.onSearchPaciente(newValue);
        if(!this.existePaciente.value)
          await this.onSearchPersona(newValue);
        this.isLoading = false;
        return;
      }
      
      this.onClearFormPaciente();
    },


  },


  computed: {

    viveInEcuador(){
      return this.residencia.pais?.token === '230';
    },


    showFormularioPersona(){

      if(this.esEditar && !this.isLoading && !this.existePaciente.value) return true;
      
      if(!this.minCaracteresIdentificacion) return false;
      if(this.isLoading) return false;
      if(this.existePaciente.value) return false;

      if(this.existePersona && this.cargoPersona) return true;
      if(!this.existePersona) return true;

      return false;
    },



    identificacionRules() {

      const tipoIdentificacion = this.paciente.tipoIdentificacion?.value;

      // Reglas de validación dinámicas basadas en el tipo de identificación
      return (tipoIdentificacion === '1') 
        ? 'required|integer|digits:10'
        : (tipoIdentificacion === '0')
          ? 'required|integer|digits:13' 
          : (tipoIdentificacion === '2') 
            ? 'required' // Para Pasaporte (números y letras)
            : null;
    },

    inputType() {
      return (this.tipoIdent === '2') 
        ? 'text'     // Pasaporte
        : 'number'; // Cédula o RUC
    },

    maxInputLength() {
      return (this.tipoIdent === '1') 
        ? 10 // Cedula
        : (this.tipoIdent === '0') 
          ? 13 // RUC
          : 20 // Pasaporte
    },

    minInputLength() {
      return (this.tipoIdent === '1')
        ? 10
        : (this.tipoIdent === '0')
          ? 13
          : 3
    },


  },


  watch:{
    
    numHistoriaClinica(newValue){
      if(!newValue) return;
      const historiaSinLetras = newValue.replace(/[^0-9]/g, '');
      this.numHistoriaClinica = historiaSinLetras;
    },


    'paciente.profesion':{
      async handler(newValue){
        if(!newValue?.text) return;

        const search = await getItemByTextUpperCase(this.optsProfesiones, newValue.text)
        
        if(!search){
          this.paciente.profesion.text = newValue?.text.toUpperCase();
          this.paciente.profesion.value = newValue?.value || '00';
          return;
        }
        this.paciente.profesion = search;
        
      }
    },

    'paciente.nacionalidad':{
      async handler(newValue){
        if(!newValue?.text) return;

        const search = await getItemByTextUpperCase(this.optsNacionalidades, newValue.text)
        if(!search){
          this.paciente.nacionalidad.text = newValue?.text.toUpperCase();
          this.paciente.nacionalidad.value = newValue?.value || '00';
          return;
        }

        this.paciente.nacionalidad = search;
      }
    },

    isModalFileVisible(newValue) {
      
      if(!newValue) {
        this.urlFileToView  = null;
        this.fileToView     = null;
        this.isRutaCompleta = false;
      }
    },

    'paciente.identificacion':{
      async handler(newValue){
        const normalizedValue = this.normalizeIdentificacion(newValue);

        if (normalizedValue !== newValue) {
          this.paciente.identificacion = normalizedValue;
          return;
        }

        await this.onChangeInputIdentificacion(newValue);
        this.cargaInicial = false;
      }
    },

    tipoIdent() {
      this.tipoIdentValidation = null;
      this.tipoIdentErrors = [];
      this.identificacionValidation = null;
      this.identificacionErrors = [];
      this.paciente.identificacion = this.normalizeIdentificacion(this.paciente.identificacion || '');
    },

    'residencia.pais': {
      async handler(newValue) {
        if(!newValue) {
          this.residencia.provincia = null;
          return;
        }       
        this.optsProvincia = await infoPersonasService.getProvinciasJson(newValue.value);
      }
    },

    'residencia.provincia':{
      async handler(newValue){
        if (this.cargaInicial) return;
        this.residencia.canton = null; 
        this.optsCanton = await infoPersonasService.getCantonesJson(newValue.value);
      }
    },

    'residencia.canton':{
      async handler(newValue){
        if (this.cargaInicial) return;
        this.residencia.parroquia = null;
        this.optsParroquia = await infoPersonasService.getParroquiasJson(newValue.value);
      }
    },


    'residencia.barrio':{
      handler(newValue){
        if(!newValue) return;
        this.residencia.barrio = newValue.toUpperCase();
      }
    },

  }

}
</script>


<style>

.flatpickr-container{
  padding: 0.438rem 1rem;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  display: block;
  width: 100%;
  height: 2.714rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.45;
  color: #6e6b7b;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
</style>
